// @ts-check
(() => {
  /**
   * @param {string} text
   * @returns {string}
   */
  function slugify(text) {
    return (text || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  /**
   * @param {HTMLElement} root
   */
  function initFaqs(root) {
    /** @type {HTMLUListElement|null} */
    const cats = root.querySelector(
      "[data-faqs-categories] .faqs__categories-list"
    );
    /** @type {HTMLElement[]} */
    const groups = Array.from(root.querySelectorAll(".faq-group"));
    if (!cats || groups.length === 0) return;

    cats.innerHTML = "";

    groups.forEach((group) => {
      const h3 = group.querySelector("h3");
      if (!h3) return;
      const id =
        h3.id ||
        slugify(h3.textContent || "") ||
        `group-${Math.random().toString(36).slice(2)}`;
      h3.id = id;

      const count = group.querySelectorAll(".details").length;

      const li = document.createElement("li");
      const a = document.createElement("a");
      a.className = "faqs__category-link";
      a.href = `#${id}`;
      a.textContent = (h3.textContent || "").trim();
      const badge = document.createElement("span");
      badge.className = "faqs__category-count";
      badge.textContent = String(count);
      a.appendChild(badge);
      li.appendChild(a);
      cats.appendChild(li);
    });

    // Mark active as user scrolls
    /** @type {NodeListOf<HTMLAnchorElement>} */
    const links = cats.querySelectorAll(".faqs__category-link");
    /** @type {HTMLHeadingElement[]} */
    const headings = groups
      .map(
        (g) => /** @type {HTMLHeadingElement|null} */ (g.querySelector("h3"))
      )
      .filter((h) => h !== null);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id;
          const link = cats.querySelector(
            `.faqs__category-link[href="#${id}"]`
          );
          if (!link) return;
          if (entry.isIntersecting) {
            links.forEach((linkEl) => linkEl.removeAttribute("aria-current"));
            link.setAttribute("aria-current", "true");
          }
        });
      },
      { rootMargin: "0px 0px -60% 0px", threshold: 0.01 }
    );
    headings.forEach((h) => observer.observe(h));

    // Apply sticky offset from setting
    const offset = root.dataset.stickyOffset;
    if (offset) {
      root.style.setProperty("--sticky-top", `${offset}px`);
    }

    // Search: open FAQs that match query, close others
    /** @type {HTMLInputElement|null} */
    const searchInput = root.querySelector('[data-faqs-search-input]');
    /** @type {HTMLDetailsElement[]} */
    const allDetails = Array.from(root.querySelectorAll('.details'));

    /**
     * @param {string} q
     */
    function runSearch(q) {
      const query = (q || '').trim().toLowerCase();
      if (!query) {
        allDetails.forEach((d) => (d.open = false));
        return;
      }
      /** @type {HTMLDetailsElement | null} */
      let firstMatch = null;
      allDetails.forEach((d) => {
        const headerText = (d.querySelector('.details__header')?.textContent || '').toLowerCase();
        const contentText = (d.querySelector('.details-content')?.textContent || '').toLowerCase();
        const isMatch = headerText.includes(query) || contentText.includes(query);
        d.open = isMatch;
        if (isMatch && !firstMatch) firstMatch = d;
      });
      if (firstMatch) {
        firstMatch.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => runSearch(searchInput.value));
      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          searchInput.value = '';
          runSearch('');
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-faqs]").forEach((root) => {
      initFaqs(/** @type {HTMLElement} */ (root));
    });
  });
})();
